import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Table } from '@cureskin/api-client';
import { ConnectionService } from '../../../../services/connection-service';

interface InvestigationData {
  tests: { test: string, required: boolean }[];
  name: string;
  description?: string;
}

@Component({
    selector: 'investigation-edit',
    templateUrl: './edit.html',
    standalone: false,
})
export class EditComponent implements OnInit {
  investigationId: string;
  investigation: InvestigationData;
  newTest: string = '';
  newTestRequired: boolean = true;

  constructor(
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly conn: ConnectionService,
  ) {}

  async ngOnInit(): Promise<void> {
    this.investigationId = this.route.snapshot.params['id'];
    if (this.investigationId) {
      this.investigation = await this.conn.findInvestigationById(this.investigationId);
    } else {
      this.investigation = { tests: [], name: '' };
    }
  }

  get tests(): Array<{ test: string, required: boolean }> {
    return this.investigation?.tests || [];
  }

  addTest(): void {
    const trimmed: string = (this.newTest || '').trim();
    if (!trimmed) return;
    const current: Array<{ test: string, required: boolean }> = [...this.tests];
    current.push({ test: trimmed, required: this.newTestRequired });
    this.investigation.tests = current;
    this.newTest = '';
    this.newTestRequired = true;
  }

  removeTest(index: number): void {
    const current: Array<{ test: string, required: boolean }> = [...this.tests];
    current.splice(index, 1);
    this.investigation.tests = current;
  }

  toggleRequired(index: number): void {
    const current: Array<{ test: string, required: boolean }> = [...this.tests];
    current[index].required = !current[index].required;
    this.investigation.tests = current;
  }

  async saveInvestigation(): Promise<void> {
    if (this.investigationId) {
      await this.conn.updateInvestigation(this.investigationId, { tests: this.investigation.tests, name: this.investigation.name, description: this.investigation.description });
    } else {
      await this.conn.createInvestigation(this.investigation);
    }
    this.router.navigate(['/products/investigations']);
  }
}
